import RadioModule from './radio.module'

export default RadioModule
